import axios from '../../plugins/axios';

/**
 *
 * @param {Object} data - Данные продавца
 * @param {number} data.id - ID продавца (0 для нового)
 * @param {string} data.FirstName - Имя
 * @param {string} data.LastName - Фамилия
 * @param {string} data.MiddleName - Отчество
 * @param {string} data.IIN - ИИН
 * @param {string} data.DOCUMENT_GIVED_DATE - Дата выдачи документа
 * @param {string} data.DOCUMENT_NUMBER - Номер удостоверения
 * @param {string} data.ADDRESS - Адрес
 * @param {string} data.CONTACT_PHONE - Телефон
 * @param {number} data.CarId - ID автомобиля
 * @param {string} data.bankAccount - Банковский счет
 * @param {string} data.bankName - Наименование банка
 * @param {string} data.bankBic - БИК
 * @returns {Promise<Object>}
 */
export async function createSeller(data) {
  const formData = new FormData();
  formData.append('json', JSON.stringify(data));

  const response = await axios.post(
    '/api/crm/cars/createSeller', formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    }
  );
  return response.data;
} 